var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { is } from "../is";
import { useState, useRef } from "react";
import { useEffectOnce } from "../Effect/useEffectOnce";
export function Clickable(props) {
    const { children, canBubble = false, activeStyle = {
        opacity: 0.5
    }, onClick = () => { } } = props, attributes = __rest(props, ["children", "canBubble", "activeStyle", "onClick"]);
    /**
     * 元素的样式
     */
    const [style, setStyle] = useState(undefined);
    /**
     * 容器元素的引用
     */
    const container = useRef(null);
    /**
     * 是否是激活状态
     */
    const active = useRef(false);
    const handleStart = (event) => {
        if (!active.current) {
            active.current = true;
            if (!canBubble) {
                event.stopPropagation();
            }
            setStyle(Object.assign({}, activeStyle));
        }
    };
    const handleEnd = (x, y, event) => {
        if (active.current) {
            // 获取鼠标弹起时的元素
            const endElement = document.elementFromPoint(x, y);
            // 只有当触摸结束时在目标元素上才触发事件
            if (container.current.contains(endElement)) {
                onClick(event);
            }
        }
        active.current = false;
        setStyle(undefined);
    };
    const eventBinding = {};
    if (is.touchable()) {
        /**
         * 触摸环境逻辑处理
         */
        eventBinding.onTouchStart = handleStart;
        const onEnd = (event) => {
            const touch = event.changedTouches[0];
            handleEnd(touch.clientX, touch.clientY, event);
        };
        eventBinding.onTouchEnd = onEnd;
        eventBinding.onTouchCancel = onEnd;
    }
    else {
        /**
         * 非触摸环境逻辑处理
         */
        eventBinding.onMouseDown = handleStart;
    }
    useEffectOnce(() => {
        /**
         * 鼠标在目标中按下，但移开目标时弹起，目标不会触发mouseup事件
         * 这一点根touchend有区别
         */
        if (!is.touchable()) {
            const mosueup = (event) => {
                handleEnd(event.clientX, event.clientY, event);
            };
            document.documentElement.addEventListener("mouseup", mosueup);
            return () => {
                document.documentElement.removeEventListener("mouseup", mosueup);
            };
        }
    });
    return (jsx("div", Object.assign({ css: style }, eventBinding, attributes, { ref: container }), children));
}
